// src/App.js

import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// 👇 Import the LanguageProvider
import { LanguageProvider } from './Context/LanguageContext';
import './App.css';

// Navbars
import NavbarDefault from './Components/Header/Header.jsx';
import NavbarUser from './Components/Header/HeaderUser.jsx';
import NavbarAdmin from './Components/Header/HeaderAdmin.jsx';
import Footer from './Components/Footer/Footer.jsx';

// Pages
import Login from './Pages/Login';
import Register from './Pages/Register';
import LoginSignup from './Pages/LoginSignup.jsx';
import Contact from './Pages/Contact.jsx';
import Home from './Pages/Home.jsx';

// Services
import WebDev from './Components/WebDev/WebDev.jsx';
import AppDev from './Components/AppDev/AppDev.jsx';
import DataAnalysis from './Components/DataAnalysis/DataAnalysis.jsx';
import Electrical from './Components/Electrical/Electrical.jsx';
import Tutorial from './Components/Tutorial/Tutorial.jsx';

// Vacancy & Bids
import Vacancy from './Components/Vacancy/Vacancy.jsx';
import Bid from './Components/Bides/Bides.jsx';
import ADDVacancy from './Components/Vacancy/add-vacancy.jsx';
import ADDBid from './Components/Bides/add-bides.jsx';

// News
import Technology from './Components/News/Technology.jsx';
import AddTechnology from './Components/News/Add_techno_news.jsx';
import Economics from './Components/News/Economics.jsx';
import ADDEconomics from './Components/News/Add_economics_news.jsx';
import Sport from './Components/News/Sport.jsx';
import ADDSport from './Components/News/Add_sport_news.jsx';
import Others from './Components/News/Others.jsx';

// Downloads & Messages
import Download from './Components/Download/Download.jsx';
import Downloadg from './Components/Download/Downloadguest.jsx';
import ADownload from './Components/Download/add_download.jsx';
import Message from './Components/Message/Message.jsx';

function App() {
  const [role, setRole] = useState(localStorage.getItem("role"));

  useEffect(() => {
    const handleStorageChange = () => {
      setRole(localStorage.getItem("role"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const renderNavbar = () => {
    // This function will now correctly render Navbars because they are inside LanguageProvider
    if (role === 'admin') return <NavbarAdmin setRole={setRole} />;
    if (role === 'user') return <NavbarUser setRole={setRole}/>;
    return <NavbarDefault setRole={setRole}/>;
  };

  return (
    // 👇 WRAP THE ENTIRE APPLICATION WITH LanguageProvider
    <LanguageProvider> 
      <BrowserRouter>
        {renderNavbar()}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login setRole={setRole} />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login-signup" element={<LoginSignup />} />
          <Route path="/contact" element={<Contact />} />

          {/* Services */}
          <Route path="/services/web-development" element={<WebDev />} />
          <Route path="/services/app-development" element={<AppDev />} />
          <Route path="/services/dashboard" element={<DataAnalysis />} />
          <Route path="/services/electrical" element={<Electrical />} />
          <Route path="/services/tutorial" element={<Tutorial />} />

          {/* Vacancy & Bid */}
          <Route path="/vacancy" element={<Vacancy />} />
          <Route path="/bid" element={<Bid />} />
          <Route path="/add-vacancy" element={<ADDVacancy />} />
          <Route path="/add-bid" element={<ADDBid />} />

          {/* News */}
          <Route path="/news/technology" element={<Technology />} />
          <Route path="/news/t1" element={<AddTechnology />} />
          <Route path="/news/economics" element={<Economics />} />
          <Route path="/news/e1" element={<ADDEconomics />} />
          <Route path="/news/sport" element={<Sport />} />
          <Route path="/news/s1" element={<ADDSport />} />
          <Route path="/news/others" element={<Others />} />

          {/* Downloads & Messaging */}
          <Route path="/download/download" element={<Download />} />
          <Route path="/download1" element={<Downloadg />} />
          <Route path="/download/d1" element={<ADownload />} />
          <Route path="/1m" element={<Message />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;